import Colors from "@/consts/Colors";
import { SelectionProps } from "@/interfaces/SelectionProps";
import { FC } from "react";
import { useForm } from "react-hook-form";
import { ArchitectureSearchQueryParameter } from "@/types/ArchitectureSearchQueryParameter";
import CheckableColorGridTile from "@/components/CheckableColorGridTile";
import SearchScafold from "@/components/SearchScafold";

const registerKey: keyof ArchitectureSearchQueryParameter = "color_type_ids";

type BuildingMaterialColorFormField = {
  color_type_ids: string[];
};

const BuildingMaterialColorSelection: FC<
  SelectionProps<ArchitectureSearchQueryParameter>
> = ({ defaultValue, onUpdate, onBack }): JSX.Element => {
  const { register, handleSubmit } = useForm<BuildingMaterialColorFormField>({
    defaultValues: {
      color_type_ids: defaultValue.color_type_ids.split(","),
    },
  });

  return (
    <SearchScafold
      handleSubmit={handleSubmit((data: BuildingMaterialColorFormField) => {
        onUpdate({
          ...data,
          color_type_ids: data.color_type_ids.join(","),
        });
        onBack();
      })}
      title={"建築材料の色"}
    >
      <div className="grid grid-cols-4">
        {Colors.map((color) => {
          const defaultChecked = defaultValue.color_type_ids
            .split(",")
            .includes(color.id.toString());

          return (
            <CheckableColorGridTile
              key={color.id}
              id={color.id.toString()}
              value={color.id.toString()}
              color={color}
              defaultChecked={defaultChecked}
              register={register(registerKey)}
            />
          );
        })}
      </div>
    </SearchScafold>
  );
};
export default BuildingMaterialColorSelection;
